import { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import { KnowledgeBaseSelection } from "./KnowledgeBaseSelection/KnowledgeBaseSelection";

import "./ChatActionBar.scss";

const RawChatActionBar: FunctionComponent = () => {
  return (
    <div className="chat-action-bar">
      <KnowledgeBaseSelection />
    </div>
  );
};

export const ChatActionBar = observer(RawChatActionBar);
